<div class="modal-content ">

  <div class="modal-header border-0 justify-content-end">

    <div class="btn btn-icon btn-sm btn-color-gray-500 btn-active-icon-primary" (click)="closeModal()"
      data-bs-toggle="tooltip" title="" data-bs-dismiss="kt_modal_view_event_edit" data-bs-original-title="Hide Event">

      <span class="svg-icon svg-icon-1">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
            fill="currentColor"></rect>
          <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="currentColor">
          </rect>
        </svg>
      </span>

    </div>

  </div>

  <div class="modal-body pt-0 pb-10 px-lg-17">
    <div class="d-flex">

      <div class="position-relative me-5">
        <p class="calendar mb-0 pb-0">{{modalData?.event?.dateFormatted}} <em>{{modalData?.event?.month}}</em></p>
      </div>

      <div class="mb-9">

        <input type="text" style="display:none" />
        <div class="d-flex align-items-center mb-1">
          <span class="fs-3 fw-bolder me-3" data-kt-calendar="event_name">{{modalData?.event?.eventTitle}}</span>
        </div>


        <!-- <div class="fs-6 mb-1" data-kt-calendar="event_description">{{modalData?.event?.date | date :'MMM d, y'}}
        </div> -->

        <div class="fs-6" data-kt-calendar="event_description" *ngIf="modalData?.event.dates?.length<=1">
          {{modalData?.event?.date | date :'MMM d, y'}}
        </div>

        <div class="fs-6" data-kt-calendar="event_description" *ngIf="modalData?.event?.dates?.length>1">
          {{modalData?.event?.dates[0]?.date | date :'MMM d, y'}} -
          {{modalData?.event?.dates[modalData?.event?.dates?.length-1]?.date | date :'MMM d, y'}}
        </div>

        <div>
          <span class="badge badge-secondary badge-sm me-3" *ngIf="modalData?.event?.eventType">
            {{formatEventTypeLabel(modalData?.event?.eventType)}}
          </span>

          <span class="badge badge-secondary badge-sm me-3" *ngIf="modalData?.event?.deliveryMode">
            {{formatEnumStringForUI(modalData?.event?.deliveryMode)}}
          </span>

          <!-- SAN-768/BRD FR-2.1: lets an applicant know up front whether
               applying books them instantly or needs admin review. -->
          <span class="badge badge-light-success badge-sm me-3" *ngIf="isAutomaticApprovalMode">
            Instant Booking
          </span>
          <!-- badge-light-warning isn't actually defined in this theme's
               compiled CSS (only badge-light-primary/-success are) -- the
               base .badge rule defaults text color to white, so an
               undefined *-light-* variant renders invisible white-on-white
               text. badge-light is the theme's own defined neutral variant. -->
          <span class="badge badge-light badge-sm me-3" *ngIf="modalData?.event?.approvalMode && !isAutomaticApprovalMode">
            Requires Approval
          </span>

        </div>

        <!-- SAN-768/BRD FR-3.2: informational only -- the API doesn't expose
             a live per-slot fill count (see SAN-790's known limitation), so
             this states the configured limits, not how close they are to
             being reached. -->
        <div class="text-muted fs-8 mt-2" *ngIf="hasApplicationCap || hasMaxSlotsPerStartup">
          <div *ngIf="hasApplicationCap">
            Up to {{modalData?.event?.applicationCap}} applicant{{modalData?.event?.applicationCap === 1 ? '' : 's'}} accepted per slot.
          </div>
          <div *ngIf="hasMaxSlotsPerStartup">
            You may apply to up to {{modalData?.event?.maxSlotsPerStartup}} slot{{modalData?.event?.maxSlotsPerStartup === 1 ? '' : 's'}} for this event.
          </div>
        </div>

      </div>
    </div>
    <div class="separator separator-dashed mt-2 mb-4"></div>
    <div class="d-flex justify-content-between align-items-start row"  *ngIf="!showChildComponent">

      <div class="col-md-6 col-12">
       

        <div class="d-flex justify-content-between align-items-center">
          <div>


            <div class="d-flex align-items-start mb-2" *ngIf="modalData?.event?.dates?.length == 1">

              <span class="svg-icon svg-icon-1 svg-icon-danger me-5">
                <i class="bi  bi-clock fs-2 header-icons-font-size"></i>
              </span>
              <div class="fs-6">
                <span class="fw-bolder me-2">Time</span>
                <div data-kt-calendar="event_start_date">{{ modalData?.event?.timeFrom}} - {{
                  modalData?.event?.timeTo }}</div>
                <div class="text-muted fs-8">{{ eventTimeZoneLabel }}</div>
              </div>
            </div>

            <div class="d-flex align-items-start mt-3"
              *ngIf="modalData?.event?.location && modalData?.event?.deliveryMode == 'in_person'">
              <span class="svg-icon svg-icon-1 svg-icon-danger me-5">
                <i class="bi bi-link-45deg fs-1 header-icons-font-size"></i>
              </span>
              <div class="fs-6 d-flex flex-column">
                <span class="fw-bolder me-2">Venue</span>
                <div data-kt-calendar="event_end_date">
                  <p class="text-black d-block text-truncate" style="width: 325px;">
                    {{ modalData?.event?.location}}
                  </p>
                </div>
              </div>
            </div>
          </div>

        </div>


        <div class="w-100 mb-5 mt-4" *ngIf="modalData.event?.headerImage&&globalSettings">
          <!-- <img [src]="modalData.event.headerImage | imagekitUrlAppender" class="rounded shadow-sm w-100 event-image" /> -->

          <lightgallery [settings]="settings">
            <!-- <ng-container *ngFor="let image of data[field.fieldCode]"> -->

              <a [href]="modalData.event?.headerImage| imagekitUrlAppender">

                <img [src]="modalData.event.headerImage | imagekitUrlAppender" class="rounded shadow-sm w-100 event-image" />
              </a>

            <!-- </ng-container> -->
          </lightgallery>

        </div>



        <div class="mt-5" *ngIf=" globalSettings">
          <p class="fw-bolder fs-4">Speakers</p>

          <div class="row">

            <div class="col-6 cursor-pointer" *ngIf="modalData.event?.speakerDetails" (click)="handleMainSpeakerClick()">
              <div class="d-flex flex-column align-items-center justify-content-center border  rounded py-4">

                <ng-container *ngIf="mainSpeaker?.speaker_image; else nameAvatar">
                  <img [src]="(mainSpeaker?.speaker_image |imagekitUrlAppender)+ '?tr=w-60,h-60'" alt="Profile image"
                    class=" bg-white rounded-circle" />
                </ng-container>
                <ng-template #nameAvatar>
                  <ngx-avatars [name]="mainSpeaker?.name" size="60"> </ngx-avatars>
                </ng-template>


                <p class="fw-bold fs-6 mt-2 mb-1">
                  {{mainSpeaker.name}}
                </p>
                <div  class="d-flex align-items-center gap-5">
                  <span class="bi bi-info-square-fill square-fill-info-custom socialIcon fs-3  ms-2 "*ngIf="mainSpeaker?.bio"
                  [ngbTooltip]="mainSpeaker.bio" container="body" placement="bottom"></span>
                  <a  target="_blank" [href]="mainSpeaker?.linkedin" class="wow fadeInLeft" *ngIf="mainSpeaker?.linkedin">
                    <i class="bi bi-linkedin socialIcon"></i>
                    </a>
                </div>
              </div>
            </div>

          <div class="col-6" *ngFor="let speaker of modalData?.event?.speakers">
            <div class="d-flex flex-column align-items-center justify-content-center border  rounded py-4">

            <ng-container *ngIf="speaker?.speaker_image; else nameAvatar">
              <img [src]="(speaker?.speaker_image |imagekitUrlAppender)+ '?tr=w-60,h-60'" alt="Profile image"
                class=" bg-white rounded-circle" />
            </ng-container>
            <ng-template #nameAvatar>
              <ngx-avatars [name]="speaker?.name" size="60"> </ngx-avatars>
            </ng-template>



              <p class="fw-bold fs-6 mt-2 mb-1">
                {{speaker.name}}
              </p>
              <div  class="d-flex align-items-center gap-5">
                <span class="bi bi-info-square-fill square-fill-info-custom socialIcon fs-3  ms-2 " *ngIf="speaker?.bio"
                [ngbTooltip]="speaker.bio" container="body" placement="bottom"></span>
                <a  target="_blank" [href]="speaker?.linkedin" class="wow fadeInLeft" *ngIf="speaker?.linkedin">
                  <i class="bi bi-linkedin socialIcon"></i>
                  </a>
              </div>
            </div>

          </div>
          </div>
        </div>


        <div class="resume-banner2 mt-8">
          <span class="fw-bolder me-2 mb-3 fs-3 text-black">Description</span>
          <div class="separator separator-custom separator-dashed mt-2 mb-4"></div>
          <div *ngIf="modalData?.event?.eventDescription" [innerHTML]="modalData?.event?.eventDescription"
          style="word-wrap: break-word;"
          >
          </div>

          <div *ngIf="!modalData?.event?.eventDescription">
            No Notes found
          </div>

        </div>
      </div>

      <div class="col-md-6 col-12">
        <ng-container *ngIf="isInPast">
          <div class="mb-5">
            <div class="alert alert-danger p-4">
              The event has already passed or has been closed for registrations.
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="!isInPast">
            <div class="fs-2">
              <span class="fw-bolder me-2">Book your slot</span>
            </div>

            <div class="fs-6 mt-1" *ngIf="hasAnyBookableSlot && modalData.event.slots?.length>1">
              <span class=" me-2">Choose date and slot</span>
            </div>

            <div class="text-muted fs-8 mt-1 d-flex align-items-center flex-wrap gap-2" *ngIf="hasAnyBookableSlot">
              <span>
                All times shown below are in {{ showTimesInViewerZone ? viewerTimeZoneLabel : eventTimeZoneLabel }}
              </span>
              <button *ngIf="isViewerInDifferentTimeZone" type="button"
                class="btn btn-link btn-sm p-0 fs-8"
                (click)="showTimesInViewerZone = !showTimesInViewerZone">
                (show in {{ showTimesInViewerZone ? eventTimeZoneLabel : viewerTimeZoneLabel }} instead)
              </button>
            </div>

            <div class="mt-4 d-flex gap-2 flex-wrap"  *ngIf="hasAnyBookableSlot && modalData.event.slots?.length>1">
              <span *ngFor="let slotObj of modalData.event.slots" (click)="selectSlotDate(slotObj)"
              class="badge badge-pill rounded-30 px-3 py-2 cursor-pointer fs-8 "
              [ngClass]="selectedSlotObj?.date === slotObj?.date ?  'badge-primary': 'badge-dark'">
              {{slotObj.date| date :'MMM d, y'}}</span>
            </div>

            <div class="alert alert-secondary mt-4 mb-0" style="color: red;" *ngIf="!hasAnyBookableSlot">
              Registrations closed. All slots have been booked.
            </div>

            <!-- BRD UX state 9 (error/API failure), shown close to the Apply
                 action rather than only as a toast that can be missed. -->
            <div class="alert mt-4 mb-0 py-3"
              [ngClass]="applyErrorSeverity === 'warning' ? 'alert-warning' : 'alert-danger'"
              *ngIf="applyErrorMessage" role="alert">
              <i class="bi bi-exclamation-triangle-fill me-2"></i>{{ applyErrorMessage }}
            </div>

            <div class="alert alert-warning mt-4 mb-0 py-3" *ngIf="eventQuestionsLoadError" role="alert">
              <i class="bi bi-exclamation-triangle-fill me-2"></i>
              Could not load the application form. You can still apply — please refresh the page if this keeps happening.
            </div>

            <div class="max-h-slots fs-5 mt-3" *ngIf="hasAnyBookableSlot">

              <!-- <ngb-accordion [closeOthers]="true" class="accordian-card-custom"
                *ngFor="let slotObj of modalData.event.slots">
                <ngb-panel id="stages">

                  <ng-template ngbPanelTitle>
                    {{slotObj.date}}
                  </ng-template>


                  <ng-template ngbPanelContent> -->
                    <ng-container *ngIf="hasAnySlotForSelectedDate; else noSlotsForSelectedDate">
                      <ng-container *ngFor="let slot of selectedSlotObj.slots">

                        <!-- Break: unchanged, own dashed-border treatment. -->
                        <div *ngIf="slot?.break" class="alert custom-bg-break p-2 text-center mb-2" style="border: 1px dotted gray !important;">
                          <p class="text-center w-100 mb-0">
                            <b>{{slot.break.title}}</b> ({{formatSlotTime(selectedSlotObj.date, slot.timeFrom)}} - {{formatSlotTime(selectedSlotObj.date, slot.timeTo)}})
                          </p>
                        </div>

                        <!-- SAN-792/BRD: one state machine per slot row --
                             getSlotView() decides, in priority order,
                             whether this row shows the startup's OWN
                             application on this exact slot (Applied/
                             Approved/Rejected), the startup's own
                             event-level limit lockout, this slot's own
                             open/closed state, or a plain Book action. -->
                        <ng-container *ngIf="!slot?.break">
                          <ng-container *ngIf="getSlotView(slot, selectedSlotObj.date) as view">

                            <!-- Approved (yours): full green row, no message/action needed. -->
                            <div *ngIf="view.kind === 'mine-approved'" class="alert alert-success p-2 d-flex justify-content-between align-items-center mb-2">
                              <span class="fw-bold">{{formatSlotTime(selectedSlotObj.date, slot.timeFrom)}} - {{formatSlotTime(selectedSlotObj.date, slot.timeTo)}}</span>
                              <span class="badge bg-success text-white fs-8"><i class="bi bi-check-circle-fill me-1"></i>Approved</span>
                            </div>

                            <!-- Rejected (yours): full red row -- a real,
                                 distinct outcome, never re-offered as a
                                 plain open slot again through this row. -->
                            <div *ngIf="view.kind === 'mine-rejected'" class="alert alert-danger p-2 d-flex justify-content-between align-items-center mb-2">
                              <span class="fw-bold">{{formatSlotTime(selectedSlotObj.date, slot.timeFrom)}} - {{formatSlotTime(selectedSlotObj.date, slot.timeTo)}}</span>
                              <span class="badge bg-danger text-white fs-8"><i class="bi bi-x-circle-fill me-1"></i>Rejected</span>
                            </div>

                            <!-- Applied (yours, pending): boxed, with the
                                 message and Withdraw action right here --
                                 not only in a separate summary elsewhere. -->
                            <div *ngIf="view.kind === 'mine-pending'" class="slot-note-box slot-note-box--info p-2 mb-2">
                              <div class="d-flex justify-content-between align-items-center">
                                <span class="fw-bold">{{formatSlotTime(selectedSlotObj.date, slot.timeFrom)}} - {{formatSlotTime(selectedSlotObj.date, slot.timeTo)}}</span>
                                <span class="d-flex align-items-center gap-2">
                                  <span class="badge badge-light-primary fs-8"><i class="bi bi-check-circle-fill me-1"></i>Applied</span>
                                  <button type="button" class="btn btn-sm btn-outline-dark py-1 px-3 fs-8"
                                    [disabled]="withdrawLoadingUuid === view.myApp.uuid"
                                    (click)="withdrawApplication(view.myApp)">
                                    {{ withdrawLoadingUuid === view.myApp.uuid ? 'Withdrawing…' : 'Withdraw' }}
                                  </button>
                                </span>
                              </div>
                              <div class="fs-8 text-muted mt-1">
                                <i class="bi bi-info-circle me-1"></i>A confirmation will be sent to you once its approved.
                              </div>
                            </div>

                            <!-- SAN-973: slot start time has already passed -- no Book action. -->
                            <div *ngIf="view.kind === 'past'" class="slot-note-box p-2 mb-2">
                              <div class="d-flex justify-content-between align-items-center">
                                <span class="text-muted">{{formatSlotTime(selectedSlotObj.date, slot.timeFrom)}} - {{formatSlotTime(selectedSlotObj.date, slot.timeTo)}}</span>
                                <span class="badge badge-light fs-8"><i class="bi bi-clock-history me-1"></i>Time passed</span>
                              </div>
                            </div>

                            <!-- Not eligible: this event is restricted to
                                 specific account types by admin's Privacy
                                 Settings, and this viewer's isn't one of
                                 them. -->
                            <div *ngIf="view.kind === 'not-eligible'" class="slot-note-box p-2 mb-2">
                              <div class="d-flex justify-content-between align-items-center">
                                <span class="text-muted">{{formatSlotTime(selectedSlotObj.date, slot.timeFrom)}} - {{formatSlotTime(selectedSlotObj.date, slot.timeTo)}}</span>
                                <button class="btn badge badge-pill rounded-30 px-5 py-2 fs-7 badge-light" disabled>
                                  <i class="bi bi-lock-fill me-1"></i>Book
                                </button>
                              </div>
                              <div class="fs-8 text-muted mt-1">
                                <i class="bi bi-info-circle me-1"></i>This event is not open to your account type.
                              </div>
                            </div>

                            <!-- SAN-887: sibling restriction -- this event is
                                 restricted to specific profile-approval
                                 statuses by admin's Privacy Settings, and
                                 this viewer's isn't one of them. -->
                            <div *ngIf="view.kind === 'not-eligible-status'" class="slot-note-box p-2 mb-2">
                              <div class="d-flex justify-content-between align-items-center">
                                <span class="text-muted">{{formatSlotTime(selectedSlotObj.date, slot.timeFrom)}} - {{formatSlotTime(selectedSlotObj.date, slot.timeTo)}}</span>
                                <button class="btn badge badge-pill rounded-30 px-5 py-2 fs-7 badge-light" disabled>
                                  <i class="bi bi-lock-fill me-1"></i>Book
                                </button>
                              </div>
                              <div class="fs-8 text-muted mt-1">
                                <i class="bi bi-info-circle me-1"></i>This event is only open to accounts with a specific profile status.
                              </div>
                            </div>

                            <!-- Full/closed (not yours): boxed, with a
                                 fill-count badge whenever a real cap is
                                 configured (Manual mode) -- a full slot
                                 always sits exactly at its cap, since the
                                 backend closes it the instant that's
                                 reached, so cap/cap is an accurate count
                                 without needing a live per-slot number from
                                 the API. -->
                            <div *ngIf="view.kind === 'full'" class="slot-note-box p-2 mb-2">
                              <div class="d-flex justify-content-between align-items-center">
                                <span class="text-muted">{{formatSlotTime(selectedSlotObj.date, slot.timeFrom)}} - {{formatSlotTime(selectedSlotObj.date, slot.timeTo)}}</span>
                                <span class="d-flex align-items-center gap-2">
                                  <span class="badge badge-light fs-8"><i class="bi bi-check-circle-fill me-1"></i>{{ closedSlotReasonLabel }}</span>
                                  <span class="text-muted fs-8" *ngIf="hasApplicationCap">
                                    <i class="bi bi-people-fill me-1"></i>{{modalData?.event?.applicationCap}}/{{modalData?.event?.applicationCap}}
                                  </span>
                                </span>
                              </div>
                              <div class="fs-8 text-muted mt-1">
                                <i class="bi bi-info-circle me-1"></i>
                                {{ hasApplicationCap ? 'Applications for this slot are full.' : closedSlotReasonTooltip }}
                              </div>
                            </div>

                            <!-- Startup's own event-level limit reached:
                                 every remaining open slot locks, even
                                 though each one individually still has
                                 room -- the block is about this startup,
                                 not this slot. -->
                            <div *ngIf="view.kind === 'limit-locked'" class="slot-note-box p-2 mb-2">
                              <div class="d-flex justify-content-between align-items-center">
                                <span class="text-muted">{{formatSlotTime(selectedSlotObj.date, slot.timeFrom)}} - {{formatSlotTime(selectedSlotObj.date, slot.timeTo)}}</span>
                                <button class="btn badge badge-pill rounded-30 px-5 py-2 fs-7 badge-light" disabled>
                                  <i class="bi bi-lock-fill me-1"></i>Book
                                </button>
                              </div>
                              <div class="fs-8 text-muted mt-1">
                                <i class="bi bi-info-circle me-1"></i>You have reached the maximum number of slots you can book for this event.
                              </div>
                            </div>

                            <!-- Open: plain enabled Book action. -->
                            <div *ngIf="view.kind === 'open'" class="alert alert-secondary-dark p-2 d-flex justify-content-between align-items-center mb-2">
                              <span>{{formatSlotTime(selectedSlotObj.date, slot.timeFrom)}} - {{formatSlotTime(selectedSlotObj.date, slot.timeTo)}}</span>
                              <button
                                class="btn badge badge-pill rounded-30 px-5 py-2 cursor-pointer fs-7 badge-dark book-btn"
                                (click)="handleBook(slot, selectedSlotObj.date)" [disabled]="bookingLoading">
                                Book

                                <span *ngIf="bookingLoading && slot.timeFrom===bookingLoadingForSlotTimeFrom">
                                  <span class="indicator-progress" [class.d-inline-block]="true">
                                    <span class="spinner-border spinner-border-sm align-middle ms-2">
                                    </span>
                                  </span>
                                </span>
                              </button>
                            </div>
                          </ng-container>
                        </ng-container>
                      </ng-container>
                    </ng-container>

                    <ng-template #noSlotsForSelectedDate>
                      <div class="alert alert-secondary mb-0">
                        No slots available for this date.
                      </div>
                    </ng-template>

                  <!-- </ng-template>

                </ngb-panel>


              </ngb-accordion> -->


            </div>
        </ng-container>
      </div>
    </div>

    <div class="row ">
      <div class="col-md-12 col-12">
        <app-attend-information
        [eventId]="eventUUID"
        [bookingData]="bookingData"
        [eventQuestionList]="eventQuestionsList"
        *ngIf="showChildComponent"
        (bookingResponseData)="bookingResponseUpdate($event)"
        [attendingType]="attendingType"
        (closeComponent)="closeChild()">
      </app-attend-information>
      </div>
    
    </div>



    <!-- <div class="d-flex justify-content-between align-items-center pt-6 flex-column alert alert-secondary-dark mt-5">
      <p class="fs-3 text-black">
        Are you attending?
      </p>
      <div class="">
        <span *ngFor="let item of globalSettings?.platformEventResponseActions" (click)="selectResponse(item)"
          class="badge badge-pill rounded-30 px-5 py-3 cursor-pointer me-3 fs-6 "
          [ngClass]="item.value === selectedResponse?.value ?  'badge-primary': 'badge-dark'">
          {{item.name}}</span>
      </div>
      <div *ngIf="modalData?.event?.date && selectedResponse?.value === 'attending'" class="mt-4">
        <add-to-calendar-button [attr.name]="modalData?.event?.eventTitle"
          [attr.description]="modalData?.event?.eventDescription" [attr.location]="modalData?.event?.rsvpUrl"
          timeZone="Asia/Calcutta" location="World Wide Web"
          options="'Apple','Google','iCal','Yahoo','Microsoft365','MicrosoftTeams','Outlook.com'" style="width: 100%;"
          [attr.startTime]="formatTo24Hour(modalData?.event?.timeFrom)"
          [attr.endTime]="formatTo24Hour(modalData?.event?.timeTo)" [attr.startDate]="modalData.event.date"
          trigger="click" label="Add to calender"></add-to-calendar-button>
      </div>
    </div> -->





  </div>

</div>
